import { useEffect, useState } from "react"
import * as React from "react"
import { Alert, Button, Form, Input } from "antd"
import { FormComponentProps } from "antd/lib/form"
import { useTranslation } from "react-i18next"
import AppProps from "../../util/AppProps"
import { accountApi } from "../../api/account"
import './style.css'

const FormItem = Form.Item
interface State {
    token: string | undefined
    error: string | undefined
    success: string | undefined
}

const ResetPasswordForm = (props: FormComponentProps & AppProps) => {
    const { t } = useTranslation("global")

    const [state, setState] = useState<State>({
        token: undefined,
        error: undefined,
        success: undefined,
    })

    const onSubmit = (e) => {
        e.preventDefault()
        setState({ ...state, error: "" })

        props.form.validateFields((err, values) => {
            if (err) {
                return
            }

            const { token } = state

            if (token == undefined) {
                setState({ ...state, error: t("Token is null or empty, cannot reset password") })
                return
            }

            accountApi.resetPassword(token, values.password, values.passwordConfirm).then(
                () => {
                    setState({
                        ...state,
                        success: t("Password was updated. You can use new password to access system"),
                    })
                },
                (errorMessage) => {
                    setState({ ...state, error: errorMessage.error })
                }
            )
        })
    }

    useEffect(() => {
        const params = new URLSearchParams(props.location.search)
        setState({ ...state, token: params.get("token") as string })
    }, [])

    const { getFieldDecorator } = props.form
    return state.success ? (
        <Alert className="reset-password-success" type="success" message={state.success} />
    ) : (
        <Form onSubmit={onSubmit} className="login-form">
            <FormItem>
                {getFieldDecorator("password", {
                    rules: [{ required: true, message: t("Please input a new password") }],
                })(
                    <div className="form-group-input">
                        <Input
                            id="passInput"
                            className="form-control-input"
                            size="large"
                            type="password"
                            placeholder=" "
                        />
                        <label htmlFor="passInput" className="form-control-placeholder">
                            {t("Please input a new password")}
                        </label>
                    </div>
                )}
            </FormItem>
            <FormItem>
                {getFieldDecorator("passwordConfirm", {
                    rules: [{ required: true, message: t("Please confirm a new password") }],
                })(
                    <div className="form-group-input">
                        <Input
                            id="passConfInput"
                            className="form-control-input"
                            size="large"
                            type="password"
                            placeholder=" "
                        />
                        <label htmlFor="passConfInput" className="form-control-placeholder">
                            {t("Confirm password")}
                        </label>
                    </div>
                )}
            </FormItem>
            <FormItem>
                <Button type="primary" htmlType="submit" className="reset-form-button">
                    {t("Continue")}
                </Button>
            </FormItem>
            {state.error && (
                <div className="login-form-alert">
                    <img src={"/images/error_alert.png"} alt="" />
                    {state.error}
                </div>
            )}
        </Form>
    )
}

const ResetPassword = Form.create()(ResetPasswordForm)

export default ResetPassword



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/resetpassword/ResetPassword.tsx